<script>
  import UiSelectButtonList from '@/components/UI/SelectButton/_subs/UiSelectButtonList'

  /**
   * @module component - CtkListFiltersSelectList
   */
  export default {
    name: 'CtkListFiltersSelectList',
    render (h) {
      return h(UiSelectButtonList, {
        class: ['ctk-list-filters-select-list'],
        on: {
          ...this.$listeners
        },
        attrs: {
          ...this.$attrs
        },
        props: {
          ...this.$props
        },
        scopedSlots: {
          default: () => this.$slots.default
        }
      })
    }
  }
</script>
